import { InfoWrapper } from '../AISCard';
import { ModifiedWeatherResponce } from 'app/api/marine-infrastructure';
import styles from './WeatherBlock.module.scss';
import { WEATHER } from './WeatherConst';
import moment from 'moment';
import { Icon } from '../Icon';
import { getI18n, useTranslation } from 'react-i18next';
import { timeByZone } from '../../helpers/timeHelper';
import { formatWindDirection } from '../../helpers/formatWindDirection';
import { useAppSelector } from 'app/store/store';
import { useMemo } from 'react';

export const WeatherBlock = ({ weather, full, utc }: ModifiedWeatherResponce) => {
  const { t } = useTranslation();
  const profile = useAppSelector((state) => state.userSlice.profile);
  const isLocalTz = useMemo(() => profile?.ui?.['isLocalTz'] === 'true' ?? true, [profile]);

  const itemData = () =>
    WEATHER.find((item) => {
      return item.id === weather.weather[0].id;
    });
  const language = getI18n().language;

  const timeFormat = useMemo(() => {
    const settingFormat = profile?.ui?.['timeFormat'] || 'HH:mm:ss';

    return settingFormat.split(':ss').join('');
  }, [profile]);
  return (
    <div className={styles.wrapper} data-full={full}>
      {weather && (
        <>
          <div className={styles.col}>
            <div className={styles.row}>
              <Icon name={`${itemData()?.ais_icon_name}`} color={'var(--default-primary)'} />
              <InfoWrapper
                label={`${language === 'ru' ? itemData()?.ru : itemData()?.en}`}
                value={<>{Math.round(weather.main.temp)}&deg;C</>}
              />
            </div>
            <div className={styles.extra_margin}>
              <InfoWrapper
                label={full ? `${t('PressureHumidityFull')}:` : `${t('PressureHumidity')}:`}
                value={
                  <>
                    {Math.round(weather.main.pressure * (3 / 4))} {t('PressureUnit')},&nbsp;
                    {weather.main.humidity}&#37;
                  </>
                }
              />
              <InfoWrapper
                label={`${t('Wind')}:`}
                value={
                  weather.wind.speed && weather.wind.deg ? (
                    <>
                      {weather.wind.speed} {t('WindSpeedUnit')}, {formatWindDirection(weather.wind.deg)}
                    </>
                  ) : undefined
                }
              />
              {full && (
                <InfoWrapper
                  label={`${t('WindGust')}:`}
                  value={weather.wind.gust ? weather.wind.gust + '\u0020' + t('WindSpeedUnit') : undefined}
                />
              )}
            </div>
          </div>
          <div className={styles.col}>
            <div className={styles.extra_margin}>
              <InfoWrapper
                label={`${t('Visibility')}:`}
                value={
                  <>
                    {weather.visibility} {t('MeterUnit')}
                  </>
                }
              />
              <InfoWrapper
                label={`${t('SunriseSunset')}:`}
                value={
                  <>
                    {timeByZone(weather.coord.lat, weather.coord.lon, weather.sys.sunrise, timeFormat) +
                      ' — ' +
                      timeByZone(weather.coord.lat, weather.coord.lon, weather.sys.sunset, timeFormat)}{' '}
                    {utc}
                  </>
                }
              />
              {full && (
                <InfoWrapper
                  label={`${t('DataObtained')}:`}
                  value={
                    isLocalTz ? (
                      <>{moment.unix(weather.dt).locale('en').format(timeFormat)}</>
                    ) : (
                      <>{`${moment.unix(weather.dt).utc().locale('en').format(timeFormat)} (UTC)`}</>
                    )
                  }
                />
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
